<template>
    <Modal class="modal modal--mob modal-radio-buttons">
        <template #header>
            <h2>{{$t('form_fields.net_worth_label')}}</h2>
        </template>
        <template #body>
            <div v-for="n in netWorthOptions" :key="n.code" class="radiobox">
                <input class="form-check-input" type="radio" :id="n.code" :checked="value === n.value">
                <label @click="update(n.value)" class="radiobox__label" :for="n.code">
                    {{$t(`form_fields.net_worth_options_${n.value}`)}}
                </label>
            </div>
        </template>
        <template #footer>
            <a @click="$emit('success')" class="skip">{{$t('credits.skip_for_now')}}</a>
        </template>
    </Modal>
</template>

<script>

import Modal from "@/components/generic/Modal";
import { netWorth } from "@/service/forms"
import AuthenticatedMixin from "@/mixins/AuthenticatedMixin";

export default {
    name: "OnDemandNetWorth",
    mixins: [AuthenticatedMixin],
    components: { Modal },
    props: {
        value: {
            type: [Number, null],
            required: true
        }
    },

    methods: {

        update(value) {

            this.$emit('set', {
                net_worth: value
            })

        }

    },

    created() {
        this.netWorthOptions = netWorth
    },
    mounted() {
        this.netWorth = this.auth.user.net_worth
    },
    beforeUnmount() {
        clearTimeout(this.timeout)
    }
}
</script>